export enum TicketTemplateChannel {
  Online = 'Online',
  Admin = 'Admin',
  Promoter = 'Promoter',
  Protocol = 'Protocol',
}
